import React from "react";
import StatCard from "../../StatCard";

// =============================================================================
// SETTER STATS
// =============================================================================
// PURPOSE: Dashboard section for setter role — quality and booking metrics.
//
// VISIBILITY: Only shown to setters (see roleConfig.ts).
//
// DISPLAYED METRICS:
// - Quality score (0-10 scale, based on conversation depth + show rate)
// - Conversation depth (avg minutes per DM conversation)
// - Sets booked (calls scheduled)
// - Show up rate (booked calls that attended)
// - Avg response time (minutes to first reply in DMs)
//
// DESIGN DECISION: Setters are measured on booking quality, not closing revenue.
// Their dashboard focuses on engagement metrics that predict downstream success.
// =============================================================================

interface SetterStatsProps {
  kpis: {
    setterQualityScore: number;
    conversationDepth: number;
    callsBooked: number;
    showUpRate: number;
    avgResponseTime: number;
  };
  getSamples: (key: string) => any[];
}

const SetterStats: React.FC<SetterStatsProps> = ({ kpis, getSamples }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6">
    <StatCard
      title="Quality Score"
      value={kpis.setterQualityScore > 0 ? `${kpis.setterQualityScore}/10` : "--"}
      subtext={kpis.setterQualityScore === 0 ? "No data yet" : undefined}
      metricKey="setterQualityScore"
      getSamples={getSamples}
    />
    <StatCard
      title="Conversation Depth"
      value={kpis.conversationDepth > 0 ? `${kpis.conversationDepth} min` : "--"}
      subtext={kpis.conversationDepth === 0 ? "No data yet" : undefined}
      metricKey="conversationDepth"
      getSamples={getSamples}
    />
    <StatCard
      title="Sets Booked"
      value={kpis.callsBooked.toString()}
      metricKey="callsBooked"
      getSamples={getSamples}
    />
    <StatCard
      title="Show Up Rate"
      value={`${kpis.showUpRate.toFixed(1)}%`}
      metricKey="showUpRate"
      getSamples={getSamples}
    />
    <StatCard
      title="Avg Response Time"
      value={kpis.avgResponseTime > 0 ? `${kpis.avgResponseTime} min` : "--"}
      subtext={kpis.avgResponseTime === 0 ? "No data yet" : undefined}
      metricKey="avgResponseTime"
      getSamples={getSamples}
    />
  </div>
);

export default SetterStats;
